import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Logo from "../assets/logo.png";
import Alert from "@mui/material/Alert";

function VentanaCrear(props) {
  const [nbre, setNbre] = useState("");
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [show, setShow] = useState(true);
  const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;</>;

  const handleClose = () => {
    props.setMostrarCrear(false);
    setShow(false);
  };

  const grabar = (event) => {
    event.preventDefault();
    if (nbre === "") {
      setMostrarAlerta(true);
    } else {
      setMostrarAlerta(false);
      setShow(false);
      props.grabarCampo(nbre);
      props.setMostrarCrear(false);
    }
  };

  return (
    <>
      <Modal
        show={props.mostrarCrear}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <img
            src={Logo}
            className="img-fluid"
            width="80px"
            height="80px"
            alt="logo"
          />
          <Modal.Title>
            {tab} {props.titulo}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert icon={false} severity="info">
            Por favor digite un Nombre
          </Alert>

          <FormControl fullWidth sx={{ m: 1 }}>
            <InputLabel htmlFor="nbre">Nombre</InputLabel>
            <OutlinedInput
              id="nbre"
              onChange={(event) => {
                setNbre(event.target.value);
              }}
            />
          </FormControl>

          {mostrarAlerta && (
            <Alert severity="error">Por favor escriba un Nombre!</Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={(event) => grabar(event)}>
            Grabar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default VentanaCrear;
